// Toast notification utility

let toastContainer = null;

// Создаем контейнер для toast уведомлений
function getToastContainer() {
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.className = "toast-container";
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
}

// Показывает toast уведомление
export function showToast(title, message, type = "success", duration = 3000) {
  const container = getToastContainer();

  // Создаем toast элемент
  const toast = document.createElement("div");
  toast.className = `toast ${type}`;

  // Иконка
  const icon = document.createElement("div");
  icon.className = "toast-icon";

  if (type === "success") {
    icon.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
      </svg>
    `;
  } else if (type === "error") {
    icon.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
      </svg>
    `;
  }

  // Контент
  const content = document.createElement("div");
  content.className = "toast-content";

  const titleEl = document.createElement("div");
  titleEl.className = "toast-title";
  titleEl.textContent = title;

  if (message) {
    const messageEl = document.createElement("div");
    messageEl.className = "toast-message";
    messageEl.textContent = message;
    content.appendChild(titleEl);
    content.appendChild(messageEl);
  } else {
    content.appendChild(titleEl);
  }

  // Собираем toast
  toast.appendChild(icon);
  toast.appendChild(content);

  // Добавляем в контейнер
  container.appendChild(toast);

  // Удаляем через указанное время
  setTimeout(() => {
    if (toast && toast.parentNode) {
      toast.parentNode.removeChild(toast);
    }
  }, duration);
}

// Упрощенные функции
export function showSuccessToast(title, message) {
  showToast(title, message, "success");
}

export function showErrorToast(title, message) {
  showToast(title, message, "error");
}
